import {
  SET_TRANSFER_TYPE_DROPDOWN,
  SET_DIVISION_DROPDOWN,
  SET_COSTCENTER_DROPDOWN,
  SET_ASSET_INFO_STEPPER_DATA
} from "./types";
const initialState = {
  transferType: [],  
  division:[],
  costCenter:[],
  assetStepperData: {},
};
const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_TRANSFER_TYPE_DROPDOWN:
      return {
        ...state,
        transferType: action.payload,
      };
    case SET_DIVISION_DROPDOWN:
      return {
        ...state,
        division: action.payload,
      };
    case SET_COSTCENTER_DROPDOWN:
    return {
      ...state,
      costCenter: action.payload,
    };
    case SET_ASSET_INFO_STEPPER_DATA:
      return {
        ...state,
        assetStepperData: action.payload,
    };
    default:
      return state;
  }
};

export default reducer;
